import React from 'react';
import { SelectInput, SelectInputProps } from '../select-input';

/**
 * Wrapper over `Select` component that accept `string[]` as value and invoke `onChangeValue` with `string[]`.
 */
export const MultiSelect = React.forwardRef<HTMLSelectElement, SelectInputProps>(function MultipleSelectCom({ onChange, ...selectProps }, ref) {
    return <SelectInput className="multi" onChange={onChange} {...selectProps} multiple={true} ref={ref} />;
});
